// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import { AddressInfoDisplayStyles } from "@insite/content-library/Components/AddressInfoDisplay";
import Icon from "@insite/mobius/Icon";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import Tooltip from "@werner/MobiusOverrides/Tooltip/Tooltip";
import AddressInfoDisplay, { XngAddressInfoDisplayProps } from "@werner/Overrides/Components/AddressInfoDisplay";
import Exclamation from "@werner/XDL/Icons/Exclamation";
import { isSiteMessageEmpty, mergeWithCss } from "@werner/XDL/Utilities";
import React, { useState } from "react";
import { css } from "styled-components";

interface Props extends XngAddressInfoDisplayProps {
    title: string;
    extendedStyles?: AddressOverviewStyles;
}

interface AddressOverviewStyles {
    wrapper?: InjectableCss;
    titleText?: TypographyProps;
    addressDisplay?: AddressInfoDisplayStyles;
}

export const addressOverviewStyles: AddressOverviewStyles = {
    wrapper: {
        css: css`
            margin-bottom: 16px;
        `,
    },
    titleText: {
        as: "p",
        size: 15,
        weight: "bold",
        css: css`
            letter-spacing: 0;
            line-height: 17px;
            margin-bottom: 12px;
            @media print {
                font-size: 12px;
            }
        `,
    },
};

const AddressOverview: React.FC<Props> = ({
    title,
    companyName,
    address1,
    address2,
    city,
    state,
    postalCode,
    customerNumber,
    extendedStyles,
}) => {
    const [styles] = useState(() => mergeWithCss(addressOverviewStyles, extendedStyles));
    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.titleText}>{title}</Typography>
            <AddressInfoDisplay
                companyName={companyName}
                address1={address1}
                address2={address2}
                city={city}
                state={state}
                postalCode={postalCode}
                customerNumber={customerNumber}
                extendedStyles={styles.addressDisplay}
            />
        </StyledWrapper>
    );
};

export default AddressOverview;
